<template lang="pug">
  vm-tabs
    vm-tab(vm-label='Recepción de productos')
      modal-reception(:id="detail" :shipment="shippment" :purchase_order_detail_id="purchase_order_detail_id")
      vm-col.card(vm-sm=12)
        vm-row(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
          vm-col(vm-justify="center", vm-align="center", vm-w=2)
            .input__wrapper
              vm-button(icon="checkmark-circle-2-outline" :color="statusColor" :disabled="true" width="100%" ) {{ status }}
        vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
          vm-col(vm-w=6)
            vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
              vm-col(vm-justify="center", vm-align="center", vm-w=5)
                b-form-group
                  vm-select(:placeholder='$t("strings.shippments")' v-model="shippment" :label='$t("strings.shippments")')
                    vm-select-item(:key="index" :value="shippment.id" :text="`${shippment.parcel} - ${shippment.guide_number}`" v-for="(shippment, index) in supplierShippments")
                    vm-select-item(value="0x" text="Envio por otro medio")
          vm-col(vm-w=6 vm-type="flex" vm-justify="flex-end")
            vm-button(icon="checkmark-circle-2-outline" @click="saveReceptions(true)" :disabled="recived_button") Recepción Total
        vm-table(max-height="500px" :data="receptions")
          template(slot="header")
            .d-flex.justify-content-between
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('receptions.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                .row
                  slot(v-if="column == 'product'") {{data[indextr][column]['name']}}
                  slot(v-if="column == 'quantity' && shippment === '0x'") {{(parseFloat(data[indextr]['quantity']) - parseFloat(data[indextr]['supplier_sent'])) - parseFloat(data[indextr]['total_receptions'])}}
                  slot(v-if="column == 'quantity' && parseInt(shippment) > 0") {{data[indextr]['remaining_receptions']}}
                  slot(v-if="column == 'recived'") {{data[indextr]['recived']}}
                  .input__wrapper(v-if="column == 'to_recived' && shippment === '0x'")
                    vm-input(class="mx-auto" autofocus :disabled="(parseFloat(data[indextr]['quantity']) - parseFloat(data[indextr]['supplier_sent']) - parseFloat(data[indextr]['total_receptions'])) === 0" v-model="data[indextr]['received_quantity']" @blur="checkValue(data[indextr])" @keyup="checkValue(data[indextr])" @keypress="checkValue(data[indextr])" style="width:100px;")
                  .input__wrapper(v-if="column == 'to_recived' && parseInt(shippment) > 0")
                    vm-input(class="mx-auto" autofocus :disabled="data[indextr]['remaining_receptions'] === 0" v-model="data[indextr]['received_quantity']" @blur="checkValue(data[indextr])" @keyup="checkValue(data[indextr])" @keypress="checkValue(data[indextr])" style="width:100px;")
                  slot(v-if="column == 'actions' && $auth.check('Admin')")
                    .actions__wrapper
                      vm-button(type="flat" icon="edit-2-outline" color="#026481" @click="editReception(data[indextr], tr)")
        vm-col(vm-w=6 vm-type="flex" vm-justify="flex-end")
          vm-button(icon="checkmark-circle-2-outline" @click="saveReceptions(false)" :disabled="touched") Recepción Parcial
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ModalReception from '@/components/modals/ModalReception.vue'
const { mapGetters, mapActions } = createNamespacedHelpers('Receptions')

export default {
  name: 'ReceptionsComponent',
  components: {
    ModalReception
  },
  props: {
    quotation_id: {
      type: Number,
      default: null
    },
    purchase_details_id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    currentPage: 1,
    param: '',
    columns: [
      'product',
      'quantity',
      'to_recived',
      'actions'
    ],
    recived_button: false,
    touched: true,
    form: {},
    detail: null,
    shippment: 0,
    status: 'Pendiente',
    statusColor: 'primary',
    displayStatus: false,
    purchase_order_detail_id: null
  }),
  validations: {},
  computed: {
    ...mapGetters(['receptions', 'supplierShippments'])
  },
  watch: {
    receptions (data) {
      if (this.shippment !== '0x') {
        this.checkReceptionsWithShippment()
      } else {
        this.checkReceptionsWithOutShippment()
      }
      this.setStatus()
    },
    shippment (shippment) {
      this.loadRecords({ purchase_order_id: this.$route.params.id, supplier_shipment_id: shippment })
    }
  },
  methods: {
    ...mapActions([
      'loadRecords',
      'addReceptions',
      'setModalReceptionVisible',
      'loadSupplierShipments',
      'loadPurchaseOrder'
    ]),
    checkValue (data) {
      if (this.shippment > 0) {
        const quantity = data.quantity_sent
        const ReceivedQuantity = data.received_quantity
        if (quantity < ReceivedQuantity) {
          data.received_quantity = data.remaining_receptions
        }
      } else if (this.shippment === '0x') {
        const quantity = data.quantity
        const ReceivedQuantity = data.received_quantity
        if ((quantity - data.remaining_receptions) < ReceivedQuantity) {
          data.received_quantity = data.quantity - data.supplier_sent
        }
      }
      let checked = 0
      this.receptions.map((reception) => {
        if (reception.received_quantity && reception.received_quantity >= 0 && reception.received_quantity != null && reception.received_quantity !== '') checked += parseFloat(reception.received_quantity)
      })

      checked > 0 ? this.touched = false : this.touched = true
    },
    saveReceptions (type) {
      if (this.shippment !== 0) {
        if (this.shippment === '0x') {
          this.handleReceptionsForShipment(type, (reception) => {
            return parseFloat(reception.quantity) - parseFloat(reception.supplier_sent) - parseFloat(reception.total_receptions)
          })
          this.saveReceptionsWithOutShippment()
        } else {
          this.handleReceptionsForShipment(type, (reception) => {
            return reception.remaining_receptions
          })
          this.saveReceptionWithShippment()
        }
      } else {
        this.showSupplierShipmentAlert()
      }
    },
    handleReceptionsForShipment (type, calculationFunction) {
      if (type) {
        this.receptions.forEach((reception) => {
          reception.received_quantity = calculationFunction(reception)
        })
        this.recived_button = true
      }
    },
    showSupplierShipmentAlert () {
      this.$vm.dialog({
        color: 'warning',
        title: this.$t('receptions.alerts.supplier_shipment'),
        text: this.$t('receptions.alerts.supplier_shipment_text'),
        acceptText: this.$t('strings.accept')
      })
    },
    editReception (data) {
      if (this.shippment !== '0x') {
        this.detail = data.id
      } else {
        this.detail = null
        this.purchase_order_detail_id = data.id
      }
      this.setModalReceptionVisible(true)
    },
    async saveReceptionWithShippment () {
      this.receptions.map((reception) => {
        if (this.quotation_id && this.quotation_id > 0) reception.quotation_id = this.quotation_id
        reception.supplier_shipment_id = this.shippment
        reception.purchase_order_id = this.$route.params.id
        reception.supplier_shipment_detail_id = reception.id
        reception.created_by = this.$auth.user().id
      })
      await this.addReceptions({ purchase_order_id: this.$route.params.id, supplier_shipment_id: this.shippment, data: this.receptions }).then(() => {
        this.loadRecords({ purchase_order_id: this.$route.params.id, supplier_shipment_id: this.shippment }).then(() => {
          this.loadPurchaseOrder({ id: this.$route.params.id }).then(() => {
            this.loadSupplierShipments({ purchase_order_id: this.$route.params.id })
          })
        })
      })
    },
    async saveReceptionsWithOutShippment () {
      this.receptions.map((reception) => {
        reception.quotation_id = this.quotation_id
        reception.purchase_order_detail_id = reception.id
        reception.purchase_order_id = this.$route.params.id
        reception.supplier_shipment_id = this.shippment
        reception.quantity_ordered = reception.quantity
        reception.created_by = this.$auth.user().id
      })
      await this.addReceptions({ purchase_order_id: this.$route.params.id, supplier_shipment_id: this.shippment, data: this.receptions }).then(() => {
        this.loadRecords({ purchase_order_id: this.$route.params.id, supplier_shipment_id: this.shippment }).then(() => {
          this.loadPurchaseOrder({ id: this.$route.params.id }).then(() => {
            this.loadSupplierShipments({ purchase_order_id: this.$route.params.id })
          })
        })
      })
    },
    checkReceptionsWithOutShippment () {
      let RemainingReceptions = 0
      this.receptions.map((reception) => {
        RemainingReceptions += (parseFloat(reception.quantity) - parseFloat(reception.supplier_sent) - parseFloat(reception.total_receptions))
      })
      if (parseInt(RemainingReceptions) === 0) {
        this.recived_button = true
        this.touched = true
      } else {
        this.recived_button = false
      }
    },
    checkReceptionsWithShippment () {
      let RemainingReceptions = 0
      this.receptions.map((reception) => {
        RemainingReceptions += parseInt(reception.remaining_receptions)
      })
      if (parseInt(RemainingReceptions) === 0) {
        this.recived_button = true
        this.touched = true
      } else {
        this.recived_button = false
      }
    },
    setStatus () {
      let checked = 0
      if (this.shippment > 0) {
        this.receptions.map((reception) => {
          checked += parseFloat(reception.remaining_receptions)
        })
      } else {
        this.receptions.map((reception) => {
          checked += (parseFloat(reception.quantity) - parseFloat(reception.supplier_sent) - parseFloat(reception.total_receptions))
        })
      }
      if (checked > 0) {
        this.statusColor = 'primary'
        this.status = 'Pendiente'
      } else if (checked === 0) {
        this.statusColor = 'success'
        this.status = 'Recepcionado'
      }
    }
  }
}
</script>

<style scoped>
.card {
  padding: 20px !important;
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
